export default __webpack_public_path__ + "static/wood4-0ebb4b1e812a7ae4333649d12f9a4913.png";